<template>
  <div>
    <VueApexCharts type="area" height="200" width="98%"  :options="chartOptions" :series="[{
      name: title,
      data: values
    }]" ></VueApexCharts>
  </div>
</template>

<script setup>
import VueApexCharts from 'vue3-apexcharts';
import {onMounted, ref, watch} from "vue";


const props = defineProps({
  title: String,
  xTitle: String,
  yTitle: String,
  values: Object,
  mapTarget :String
});

onMounted(() => {
  createChart();
})
watch(()=>props.mapTarget, (_new, _odd)=> {
  // createChart();
  chartOptions.value.markers.discrete[0].dataPointIndex = parseInt(props.mapTarget);
})

const series = ref([]);
const chartOptions = ref({});

const createChart = () => {

  chartOptions.value = {

    stroke: {
      width: 1
    },
    chart: {
      type: 'area',
      stacked: false,
      height: 350,

      zoom: {
        type: 'x',
        enabled: false,
        autoScaleYaxis: true
      },

      toolbar: {
        autoSelected: 'zoom'
      },
      events: {}
    },
    dataLabels: {
      enabled: false
    },
    markers: {
      discrete: [{
        seriesIndex: 0,
        dataPointIndex:parseInt(props.mapTarget),
        fillColor: '#ff0000',
        strokeColor: '#fff',
        size: 5,
        shape: "circle"
      },
      ]
    },
    // title: {
    //   text: props.title,
    //   align: 'left'
    // },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 90, 100]
      },
    },
    yaxis: {
      title: {
        text: props.yTitle
      }
    },
    xaxis: {
      type: 'datetime',
      format: "yyyy-MM-dd HH:mm"
    },
    tooltip: {
      shared: true,
      x: {
        show: true,
        format: "yyyy-MM-dd HH:mm"
      },
      y: {
        show: true,
        title: {
          formatter: (seriesName) => seriesName,
        }
      }
    }
  }
}
</script>

<style scoped>

</style>